"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolButton = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var classNames = require("classnames");
var __1 = require("..");
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('ToolButton'), (0, recompose_1.defaultProps)({
    color: 'blue',
    type: 'button',
    icon: React.createElement(__1.Icon, { className: "fa-plus" }),
    text: 'Tool Button',
    disabled: false
}));
var Content = function (x) { return (React.createElement(React.Fragment, null,
    React.createElement("span", { className: classNames("sok-tool-".concat(x.type, "-icon"), x.iconClassName), key: "icon" }, x.icon),
    React.createElement("span", { className: "sok-tool-".concat(x.type, "-text"), key: "text" }, x.children))); };
/**
 * Buttons used in tools sidebar
 */
exports.ToolButton = enhance(function (x) {
    if (x.link) {
        return (React.createElement(react_router_dom_1.Link, { className: classNames("sok-tool-".concat(x.type), x.className, x.color, {
                disabled: x.disabled
            }), style: x.style, to: x.link, onClick: x.onClick },
            React.createElement(Content, { iconClassName: x.iconClassName, icon: x.icon, type: x.type }, x.children || x.text)));
    }
    else {
        return (React.createElement("button", { className: classNames("sok-tool-".concat(x.type), x.className, x.color, {
                disabled: x.disabled
            }), style: x.style, onClick: x.onClick, disabled: x.disabled },
            React.createElement(Content, { iconClassName: x.iconClassName, icon: x.icon, type: x.type }, x.children || x.text)));
    }
});
//# sourceMappingURL=index.js.map